import { useState } from "react";
import { RiEdit2Line, RiEyeLine, RiPagesLine } from "react-icons/ri";
import { IPrinter } from "../..";
import { Modal } from "../../../../../../components/Modal";
import Popover from "../../../../../../components/Popover";
import { EditModal } from "../EditModal";
import { ActionItem, ActionsContainer, Container, Header, IconButtonContainer, ImageContainer, LeftContent, PrincipalInfos, RightContent } from "./styles";

interface IPrinterItem {
    printer: IPrinter;
    getPrinters: () => Promise<void>;
}

export function PrinterItem({ printer, getPrinters }: IPrinterItem) {
    const [ isModalOpen, setIsModalOpen ] = useState(false);

    return (
        <Container>
            <Header>
                <LeftContent>
                    <ImageContainer>
                        <Popover
                        position="right"
                        label={`ProductId: ${printer.device_product_id}, VendorId: ${printer.device_vendor_id}`}
                        styles={{ minWidth: "200px", maxWidth: "200px", whiteSpace: "normal" }}
                        >
                          <RiPagesLine />
                        </Popover>
                    </ImageContainer>
                    <PrincipalInfos>
                        <span className="solution">
                        { printer.name }
                        </span>
                        <span className="date">X: { printer.xyz[0] }, Y: { printer.xyz[1] }, Z: { printer.xyz[2] } </span>
                    </PrincipalInfos>
                </LeftContent>
                <RightContent>
                    <ActionsContainer>
                    <ActionItem>
                        <Popover position="left" label={`Editar ${printer.name}`}>
                            <IconButtonContainer >
                            <RiEdit2Line size={18} onClick={() => setIsModalOpen(true)}/>
                            </IconButtonContainer>
                        </Popover>
                        {
                            isModalOpen && 
                            <Modal open={isModalOpen}>
                                <EditModal
                                    printer={printer}
                                    closeModal={async () => {
                                            await getPrinters();
                                            setIsModalOpen(false);
                                        }
                                    }/>
                            </Modal>
                        }
                        </ActionItem>
                    </ActionsContainer>
                </RightContent>
            </Header>
        </Container>
    )
}